"use client"

import { usePathname } from "next/navigation"

export default function MainWrapper({ children }: { children: React.ReactNode }) {
  const pathname = usePathname()
  // Pages that render their own full-height layout (no global Header, no
  // pt-16 reservation): auth flows, the login screen, admin console,
  // and the admin-unlock gate. Letting pt-16 run on these leaves a
  // dead band above the page's own header/card — ugly on mobile where
  // screen real-estate is tight.
  const isFullBleed =
    pathname?.startsWith("/auth/")     ||
    pathname === "/login"              ||
    pathname?.startsWith("/admin")     ||
    pathname === "/admin-unlock"       ||
    pathname?.startsWith("/preview")
  // Dashboard uses a slimmer h-12 (3rem) topbar — header.tsx switches
  // height based on isDashboard. Match the padding so the cream bg
  // doesn't show a 16px dark gap between the topbar and the dashboard
  // shell. Other surfaces keep the standard 4rem reservation.
  const isDashboard = pathname?.startsWith("/dashboard")

  if (isFullBleed) {
    return <main>{children}</main>
  }

  const topPad = isDashboard
    ? "calc(3rem + var(--promo-banner-h, 0px))"
    : "calc(4rem + var(--promo-banner-h, 0px))"

  return (
    <main
      className={isDashboard ? "pt-12" : "pt-16"}
      style={{ paddingTop: topPad, background: "#FAF7EE" }}
    >
      {children}
    </main>
  )
}
